import {
    mobile,
    ios
} from '../Agent'
import {
    Environment
} from "../Base"

let _slot;

const interstitial = () => {
    if (!mobile()) return;
    if (Environment().isLocalhost) return;
    let slot = {
        cont: 'gpt-transition'
    };
    if (ios()) {
        slot.adUnit = "/6870/ynet_mobile/Frogi.maavaron.iphone.320x355";
        slot.size = [
            [1, 1],
            [1, 2]
        ];
    } else {
        slot.adUnit = "/6870/ynet_mobile/Frogi.maavaron.android.320x450";
        slot.size = [1, 2];
    }

    if (_slot) window.googletag.destroySlots([_slot]);
    window.googletag.cmd.push(function () {
        _slot = window.googletag.defineSlot(slot.adUnit, slot.size, slot.cont);
        _slot.addService(window.googletag.pubads());
        window.googletag.pubads().enableSingleRequest();
        window.googletag.enableServices();
        window.googletag.display(slot.cont);
    });
}

export {
    interstitial
}


// WEBPACK FOOTER //
// ./src/Components/Services/Adsense/ads.js